import { OfferTransitions } from './enums';

export const OFFER_ACCEPTED_TRANSITIONS = Object.freeze([
  OfferTransitions.ACCEPT_OFFER,
  OfferTransitions.ACCEPT_AFTER_COUNTER_1,
  OfferTransitions.ACCEPT_AFTER_COUNTER_2,
  OfferTransitions.ACCEPT_AFTER_COUNTER_3,
]);
export const WEIGHT = 'weight';
export const PLATFORM = 'platform';
export const OWN = 'own';
export const SHIPPING_PREFERENCE = 'shippingPreference';
export const ADD_ICON = 'addIcon';
export const ADD = 'add';
export const SUBTRACT = 'subtract';
export const SUBTRACT_ICON = 'subtractIcon';
export const DETAILS = 'details';
export const OTHER = 'other';

export const UNITS_OF_MEASUREMENT = [
  { key: 'cm', label: 'Centimeter (cm)' },
  { key: 'm', label: 'Meter (m)' },
  { key: 'in', label: 'Inch (in)' },
  { key: 'ft', label: 'Foot (ft)' },
  { key: 'yd', label: 'Yard (yd)' },
  { key: 'mm', label: 'Millimeter (mm)' },
  { key: 'kg', label: 'Kilogram (kg)' },
  { key: 'g', label: 'Gram (g)' },
  { key: 'lb', label: 'Pound (lb)' },
  { key: 'oz', label: 'Ounce (oz)' },
  { key: 'l', label: 'Liter (l)' },
  { key: 'ml', label: 'Milliliter (ml)' },
  { key: 'sq_m', label: 'Square Meter (m²)' },
  { key: 'sq_ft', label: 'Square Foot (ft²)' },
  { key: 'sq_yd', label: 'Square Yard (yd²)' },
  { key: 'pcs', label: 'Pieces (pcs)' },
];
